/**
 *
 * Highlights
 *
 */

/**
 *
 * Highlights
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import ClassNames from 'classnames';
import _isEmpty from 'lodash/isEmpty';
import Typography from '@material-ui/core/Typography';
import { isBot } from 'utils/stringUtils';
import CheckIcon from './images/check.svg';
import ErrorIcon from './images/wrong.svg';

const styles = () => ({
  root: {
    flexWrap: 'nowrap',
    background: '#F8F9F9',
    padding: '10px 20px',
    borderRadius: 19.5,
    display: 'inline-flex',
    marginRight: 5,
    marginBottom: 8,
    alignItems: 'center',
  },
  noBackground: {
    background: 'transparent',
    borderRadius: 0,
    padding: '0 !important',
    margin: '0 !important',
  },
  fullWidth: {
    display: 'flex',
    padding: '5px',
    alignItems: 'center',
  },
  iconWrapper: {
    marginRight: 5,
  },
  overlayWrapper: {
    padding: 0,
    background: 'transparent',
  },
  listWrapper: {
    listStyle: 'none',
    margin: 0,
    padding: 0,
    width: '100%',
  },
  text: {
    margin: '2px 0',
    display: 'inline',
  },
  icon: {
    display: 'inline',
    marginRight: 18,
  },
  iconOverlay: {
    marginRight: 5,
  },
});
function Highlights({ classes, data, isOverlay, noBorder }) {
  if (_isEmpty(data)) return null;
  const bot = isBot();
  return (
    <Grid
      container
      direction="row"
      className={ClassNames(
        classes.wrapper,
        isOverlay ? classes.overlayWrapper : undefined,
      )}
    >
      <ul className={classes.listWrapper}>
        {data.map((review, index) => {
          const isNegative = review.charAt(0) === '-';
          const Icon = isNegative ? ErrorIcon : CheckIcon;
          const cleanText = isNegative ? review.substr(1) : review;
          return (
            <li
              className={ClassNames(
                classes.root,
                isOverlay ? classes.fullWidth : undefined,
                noBorder ? classes.noBackground : undefined,
              )}
              key={index}
            >
              {!bot && (
                <img
                  src={Icon}
                  alt="Icon"
                  className={ClassNames(
                    classes.icon,
                    isOverlay ? classes.iconOverlay : undefined,
                  )}
                />
              )}

              <Typography
                variant="overline"
                color="textPrimary"
                align="left"
                className={classes.text}
              >
                {cleanText}
              </Typography>
            </li>
          );
        })}
      </ul>
    </Grid>
  );
}

Highlights.propTypes = {
  classes: PropTypes.object,
  data: PropTypes.array,
  isOverlay: PropTypes.bool,
  noBorder: PropTypes.bool,
};

Highlights.defaultProps = {
  noBorder: false,
};

export default withStyles(styles)(Highlights);
